import { Box } from "@mui/material";
import evIcon from "../Assets/ev.svg";
import evDisconnect from "../Assets/evDisconnect.svg";

const Ev = ({ evStatus = "" }) => {
  return (
    <Box>
      <img src={evStatus === "idle" ? evDisconnect : evIcon} alt="" />
    </Box>
  );
};

export default Ev;
